import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import PardonForm from './components/PardonForm';
import ReviewApplications from './components/ReviewApplications';

function App() {
  return (
    <Router>
      <div className="App">
        <nav style={{
          backgroundColor: '#f8f9fa',
          padding: '15px',
          marginBottom: '20px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          <div style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <Link to="/" style={{
              textDecoration: 'none',
              color: '#333',
              fontSize: '1.2em',
              fontWeight: 'bold'
            }}>
              Pardon CMS
            </Link>
            <div>
              <Link to="/" style={{
                marginRight: '15px',
                textDecoration: 'none',
                color: '#007bff'
              }}>
                Submit Application
              </Link>
              <Link to="/review" style={{
                textDecoration: 'none',
                color: '#007bff'
              }}>
                Review Applications
              </Link>
            </div>
          </div>
        </nav>

        <Routes>
          <Route path="/" element={<PardonForm />} />
          <Route path="/review" element={<ReviewApplications />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
